<template>
    <p-feature-flag
          name="Quick Menu"
          redirect
      >
      <p-search-screen
        title="Quick Menu Profiles"
        api-destination="quickmenus"
        edit-key="specialItemProfileId"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        add-new-button
        ref="searchScreen"
      >
        <template v-slot:cell(clone)="{ item }">
            <b-button
              variant="outline-primary"
              size="sm"
              @click='clone(item)'
              > Clone
            </b-button>            
        </template>
        <template v-slot:cell(makeDefault)="{ item }">
            <b-button
                  variant="outline-primary"
                  size="sm"
                  @click='makeDefault(item)'
                  > Make Default
                </b-button>
        </template>
      </p-search-screen>
    </p-feature-flag>
  </template>
  
  <script>
  import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
  import {booleanToYesNoFormatter} from "@/components/Common/Formatters.js";
  import axios from 'axios';
  
  export default {
    mixins: [SearchStorage],
    data() {
      return {
        filterName: 'QuickMenuFilter',
        filters: {
          automatic: "",
          perPage: 50,
          sortBy: 'name',
          sortDesc: true,
          searchBy:'All'
        },
        filterBy:[
            'Name'
        ],
        fields: [
          {
            key: "clone",
            tdClass: "tcw100"
          },
          {
            key: "makeDefault"
          },
          {
            key: "name",
            sortable: true
          },
          {
            key: "isDefault",
            formatter: booleanToYesNoFormatter,
            sortByFormatted: true,
            sortable: true
          }
        ]
      };
    },
    methods: {
      deepClone(obj) {
            if (obj === null || typeof obj !== "object") return obj;

            let clonedObj = Array.isArray(obj) ? [] : {};
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                  switch(key.toLowerCase()) 
                  {
                    case "name":
                      clonedObj[key] = obj[key] + " - Clone";
                      break;
                    case "default":
                      clonedObj[key] = false;
                      break;
                    case "specialitemprofileid":
                    case "specialitemgroupid":
                    case "specialitemgroupitemid":
                    case "specialitemgroupidnested":
                    case "specialItemProfileGroupId":
                    case "madetoorderpromptid":
                    case "madetoorderoptionid":
                      clonedObj[key] = 0;
                      break;
                    default:
                      clonedObj[key] = this.deepClone(obj[key]);
                      break;
                  }
                }
            }
            return clonedObj;
        },
      clone(item){ 
        axios.get('QuickMenus', { params: { id: item.specialItemProfileId } })
            .then(resp => {
              var newProfile = this.deepClone(resp.data);

              axios.post('quickmenus', newProfile)
                .then(() => {
                    this.$appSuccess('Cloned profile successfully');
                    this.$refs?.searchScreen.refreshSearchResults();
                });
              this.isBusy = false;
            });
      },
      makeDefault(item)
      {
        let specialItemProfileId = item.specialItemProfileId;
        axios.get('quickmenus/makeDefault', { params: { specialItemProfileId }})
                .then(() => {
                    item.default = true;
                    this.$appSuccess('default updated successfully');
                    this.$refs?.searchScreen.refreshSearchResults();
                });
      }
    }
  };
  </script>
  